export default {
      id: "i-excel-solid-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "img/sprite.svg#i-excel-solid",
      toString: function () {
        return this.url;
      }
    }